// Customer pickup vs delivery (contract 45136), pure helpers for the dispatch UI. The collector NAME is the slip's `driver`, the PLATE its `vehicle`.
import { defaultEta } from './dispatchEta.mjs';

export const MODES = ['delivery', 'pickup'];
export const modeOf = s => (s?.delivery_method === 'pickup' ? 'pickup' : 'delivery');   // old slips / null = delivery
export const isPickup = s => modeOf(s) === 'pickup';
// the delivering action's label key: 'Confirm pickup' for a pickup slip, 'Deliver Dispatch' otherwise (same delivery-events call underneath)
export const deliverKey = s => (isPickup(s) ? 'act_confirmPickup' : 'act_deliver');

// prefill from the partner (contract 7): mode, ETA lead time, vehicle/plate, driver/collector, collector phone; the server never defaults anything
export function partnerDefaults(defs, dispatchDate) {
  const d = defs || {};
  const mode = d.default_fulfilment === 'pickup' ? 'pickup' : 'delivery';
  return { mode, eta: defaultEta(dispatchDate, d.delivery_lead_time_days), vehicle: d.default_vehicle || '', driver: d.default_driver || '', pickup_phone: mode === 'pickup' ? d.default_contact_phone || '' : '' };
}

// a delivery location -> the deliver_to text (server-composed snapshot); '' = the user's own text
export const locationText = (locations, id) => (locations || []).find(l => l.id === id)?.snapshot_text || '';

// pickup needs the collector's name (client-side mirror of DISPATCH_PICKUP_COLLECTOR_REQUIRED; the server stays the guard)
export const collectorProblem = f => (f.delivery_method === 'pickup' && !String(f.driver || '').trim() ? 'collector' : null);

// pickup location choice = 'storage:<uuid>' | 'site:<uuid>' | '' (none: the server derives it when every line sits in ONE storage); kind AND id together, or neither (contract 45136 s9)
export const placeValue = (kind, id) => (kind && id ? `${kind}:${id}` : '');
export const placeFields = v => { const [kind, id] = String(v || '').split(':'); return kind && id ? { pickup_location_kind: kind, pickup_location_id: id } : {}; };

// FULL header body for POST and for a draft PUT (a PUT without delivery_method would turn a pickup draft into a delivery one).
// pickup: driver / vehicle / pickup_phone / pickup_id_note and NO deliver_to; delivery: deliver_to and NONE of the pickup fields (the server refuses them).
export function headerBody(f) {
  const t = v => String(v ?? '').trim() || null;
  const base = { dispatch_date: f.dispatch_date, eta: f.eta, delivery_method: f.delivery_method === 'pickup' ? 'pickup' : 'delivery', vehicle: t(f.vehicle), driver: t(f.driver), notes: t(f.notes) };
  return base.delivery_method === 'pickup'
    ? { ...base, pickup_phone: t(f.pickup_phone), pickup_id_note: t(f.pickup_id_note), ...placeFields(f.pickup_place) }
    : { ...base, deliver_to: t(f.deliver_to) };
}

// pickup location = the distinct source nodes (detail pickup_nodes, else the ticked lines' storage / band names)
export const pickupPlaces = (slip, tickedLines = []) => {
  if (slip?.pickup_location_text) return [slip.pickup_location_text];   // the chosen site / storage snapshot (contract 45136 s9) wins over the derived nodes
  const fromNodes = (slip?.pickup_nodes || []).map(n => n.node_name).filter(Boolean);
  return [...new Set(fromNodes.length ? fromNodes : tickedLines.map(l => l.storage_name || l.band_name).filter(Boolean))];
};
